var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99953 0C7.29879 0 5.10156 2.19723 5.10156 4.89797C5.10156 7.59871 7.29879 9.7959 9.99953 9.7959C12.7003 9.7959 14.8975 7.59867 14.8975 4.89793C14.8975 2.19719 12.7003 0 9.99953 0ZM9.99953 8.57144C7.97398 8.57144 6.32605 6.92351 6.32605 4.89797C6.32605 2.87242 7.97398 1.22449 9.99953 1.22449C12.0251 1.22449 13.673 2.87242 13.673 4.89797C13.673 6.92351 12.0251 8.57144 9.99953 8.57144Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 9.79688C5.38641 9.79688 1.63281 13.5505 1.63281 18.1642V18.7765H18.3675V18.1643C18.3675 13.5505 14.6139 9.79688 10.0002 9.79688ZM2.88328 17.552C3.19488 13.899 6.26781 11.0214 10.0002 11.0214C13.7325 11.0214 16.8054 13.8989 17.117 17.552H2.88328Z",
    fill: "#2667B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconBlue);
export default __webpack_public_path__ + "static/media/user_icon_blue.e45231bced9c87d5b8938d1909bcfd9e.svg";
export { ForwardRef as ReactComponent };